// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"05360eb4","237":"384b5da3","343":"f031cb82","347":"e3ca3ee9","544":"269e21e9","574":"e06e543a","821":"1c392901","928":"3b8aae9b","955":"1d792148"}[chunkId] + ".chunk.css";
};